import t from "./index808.js";
import n from "./index882.js";
function f(e, r) {
  return r.length < 2 ? e : t(e, n(r, 0, -1));
}
export {
  f as default
};
